import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetActionsQuery } from '../../actions/actionsApiSlice'
import { memo } from 'react'
import useAuth from "../../../hooks/useAuth"
import ReactQuill from 'react-quill'


const StudentGrade = ({ action }) => {
    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const navigate = useNavigate() 

    if (action) {
        const actionId = action._id;
        const responseId = action.response?._id;
        const grade = action.response?.grade || -1;

        const handleShow = () =>  navigate(`/${type}/${groupId}/my-grades/${actionId}`)
       

        return (
            <tr className="table__row">
                <td className="table__cell grade__task">{action.taskTitle}<hr />{action.title}  {action.ratio? `(${action.ratio}%)`:""}<span className='small-text'>{action.groupName}</span></td>

                <td className="table__cell grade__text">
                {(responseId )
                        ?     <ReactQuill
                        theme='bubble'
                       readOnly
                       value={ action.response.notes}
                       
                       ></ReactQuill>
                       :
                       <>
                   ***   המשימה לא הוגשה ***
                       </>
                    } 
                </td>

                <td className="table__cell grade__status">

                     {responseId
                        ? <span className="status--completed">DONE</span>
                        : <span className="status--open">MISSING</span>
                    } 
                </td>
                <td className="table__cell action__status">
                    {grade > -1
                    ? <span className="status--completed">{grade}</span>
                    : <span className="status--open">לא ניתן ציון</span>
                    } 
                </td>
                <td className="table__cell">
                   <button
                        className="icon-button table__button"
                        onClick={handleShow}
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </button>
               
                  
                </td>
            </tr>
        )

    } else return null
}

const memoizedGrade = memo(StudentGrade)

export default memoizedGrade